import styled from '@emotion/styled';
import {
    Box,
    Stack,
    Switch,
    Typography,
    Button,
    Tooltip,
    Dialog,
    DialogContent,
    DialogActions,
    Divider,
    IconButton,
    InputLabel,
    Card
} from '@mui/material';

export const StyledDividerWrapper = styled(Divider)({
    // backgroundColor: "#F5E0B5"
    backgroundColor: '#E0E0E0'
});

export const StyledSwitchWrapper = styled(Switch)`
    .MuiSwitch-switchBase.Mui-checked {
        color: #fdd588;
    }
    .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
        background-color: #fdd588;
    }
    .MuiSwitch-switchBase {
        color: #333333;
    }
`;

export const ContentWrapper = styled(Box)(() => ({
    width: '100%',
    height: 'calc(100vh - 150px)', // Fixed height with some space for header/navigation
    // padding: '24px 32px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05), 0 4px 8px rgba(0, 0, 0, 0.05)',
    border: '1px solid rgba(0, 0, 0, 0.08)',
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    overflow: 'auto',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.08), 0 8px 16px rgba(0, 0, 0, 0.08)'
    },
    // Custom scrollbar styling
    '&::-webkit-scrollbar': {
        width: '10px',
        height: '10px'
    },
    '&::-webkit-scrollbar-track': {
        background: '#f5f5f5',
        borderRadius: '8px',
        margin: '4px',
        border: '1px solid #e0e0e0'
    },
    '&::-webkit-scrollbar-thumb': {
        background: 'linear-gradient(45deg, #1a237e, #283593)',
        borderRadius: '8px',
        border: '2px solid #f5f5f5',
        transition: 'all 0.3s ease',
        '&:hover': {
            background: 'linear-gradient(45deg, #283593, #303f9f)',
            cursor: 'pointer'
        }
    },
    // Firefox scrollbar styling
    scrollbarWidth: 'thin',
    scrollbarColor: '#1a237e #f5f5f5',
    // Hide scrollbar when not hovering
    '&:not(:hover)::-webkit-scrollbar-thumb': {
        background: 'rgba(26, 35, 126, 0.5)'
    },
    '&:not(:hover)::-webkit-scrollbar-track': {
        background: 'transparent'
    },
    // Smooth scrolling
    scrollBehavior: 'smooth',
    // Custom scrollbar for Firefox
    '@-moz-document url-prefix()': {
        scrollbarWidth: 'thin',
        scrollbarColor: '#1a237e #f5f5f5'
    }
}));

export const ContentHeaderWrapper = styled(Stack)({
    width: '100%',
    display: 'flex',
    gap: '12px',
    padding: '24px 32px',
    flexDirection: 'row',
    alignItems: 'center',
    position: 'sticky',
    zIndex: 100,
    background: '#fff',
    top: 0,
    marginBottom: 4,
    justifyContent: 'space-between'
});

export const ContentHeaderTitleWrapper = styled(Box)({
    width: '100%',
    display: 'flex',
    gap: 20,
    alignItems: 'center'
});

export const ContentHeaderTitle = styled('div')({
    fontSize: '28px',
    fontWeight: '500',
    color: '#333333',
    width: '100%',
    maxWidth: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    '&::before': {
        content: '""',
        top: '10%',
        left: 0,
        backgroundColor: '#F5E0B5',
        width: '4px',
        height: '40px',
        margin: '0 15px 0 0'
    }
});

export const ContentHeaderTitleLine = styled.hr`
    width: 100%;
    padding: 0.8px;
    border: none;

    background: #f5e0b5;
`;

export const AddButtonWrapper = styled(Button)({
    textTransform: 'none',
    fontSize: '16px',
    backgroundColor: '#002047',
    color: '#ffffff',
    border: '1px solid #002047',
    padding: '2px 15px',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.0)',
    '&:hover': {
        backgroundColor: '#002047'
    },
    '&:disabled': {
        backgroundColor: '#b0bec5', // Light grey for disabled background
        color: '#757575', // Dark grey for disabled text
        border: '1px solid #b0bec5', // Light grey border for disabled button
        boxShadow: 'none', // Remove the shadow when disabled
        cursor: 'not-allowed' // Change cursor to indicate the button is not clickable
    }
});

export const CancelButtonWrapper = styled(Button)({
    textTransform: 'none',
    fontSize: '16px',
    backgroundColor: 'transparent',
    color: '#7f8c8d',
    border: '1px solid #bdc3c7',
    padding: '2px 15px',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.0)',
    '&:hover': {
        border: '1px solid #e1b12c',
        color: '#e1b12c'
    }
});

export const ContentTableWrapper = styled(Box)({
    padding: '20px 25px'
});

export const ContentTableImageWrapper = styled.img({
    width: '45px',
    height: '45px'
});

export const ContentTableActionWrapper = styled(Stack)({
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center'
});

export const ContentTooltipWrapper = styled(Tooltip)({
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: '12px',
    border: '1px solid #dadde9'
});

export const ContentDialogWrapper = styled(Dialog)({
    padding: '20px'
});

export const ContentDialogHeaderWrapper = styled(Stack)({
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 13px 10px 20px'
});

export const ContentDialogContentWrapper = styled(DialogContent)({
    // maxHeight: '600px',
    overflowY: 'auto',
    padding: '20px'
});

export const GlobalInputLabelWrapper = styled(InputLabel)({
    fontSize: 14,
    lineHeight: '17px',
    letterSpacing: 0,
    marginBottom: 8,
    color: '#333333'
});

export const GlobalInputLabelRequiredWrapper = styled.span({
    fontSize: '16px',
    color: '#D32F2F'
});

export const ContentDialogHeaderTitleWrapper = styled(Typography)({
    fontSize: '20px',
    fontWeight: '500',
    color: '#333333',
    width: '100%',
    marginRight: '17px',
    display: 'flex',
    alignItems: 'center'
});

export const CancelIconButtonWrapper = styled(IconButton)({
    float: 'right',
    color: '#333333'
});

export const ContentDialogActionsWrapper = styled(DialogActions)({
    padding: '10px 20px'
});

export const ImageUploadContainerWrapper = styled(Box)({
    position: 'relative',
    display: 'inline-block',
    width: '100%',
    borderRadius: '12px',
    textAlign: 'center',
    marginBottom: '16px'
});

export const MultipleImageUploadContainerWrapper = styled(Box)({
    position: 'relative',
    display: 'inline-block',
    borderRadius: '10px',
    textAlign: 'center',
    width: '100%'
});

export const MultipleImageWrapper = styled(Stack)({
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '10px'
});

export const ImageUploadButtonWrapper = styled(Button)(({ isError }) => ({
    padding: '16px 24px',
    backgroundColor: '#f8fafc',
    borderRadius: '8px',
    color: isError ? '#ef4444' : '#64748b',
    border: isError ? '2px dashed #ef4444' : '2px dashed #e2e8f0',
    width: '100%',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
        backgroundColor: '#f1f5f9',
        borderColor: isError ? '#ef4444' : '#94a3b8',
        color: isError ? '#ef4444' : '#475569'
    }
}));

export const MultipleImageUploadButtonWrapper = styled(Button)(({ isError }) => ({
    padding: '10px 20px',
    backgroundColor: 'transparent',
    borderRadius: '10px',
    color: '#333333',
    border: isError ? `2px solid red` : `2px solid #F5E0B5`,
    width: '100%'
}));

export const ImageUploadInputFileWrapper = styled.input`
    position: absolute;
    width: 100%;
    height: 100%;
    cursor: pointer;
    top: 0;
    right: 0;
    opacity: 0;
    z-index: 1;
    &:disabled {
        cursor: not-allowed;
    }
    &:disabled + .image-actions {
        opacity: 0;
    }
`;

export const ImageUploadValidationMessageWrapper = styled(Typography)({
    color: '#ef4444',
    fontSize: '12px',
    marginTop: '8px',
    textAlign: 'left'
});

export const ImageUploadPreviewWrapper = styled(Box)(({ image }) => ({
    height: '160px',
    width: '100%',
    backgroundImage: `url(${image})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    borderRadius: '8px',
    position: 'relative',
    overflow: 'hidden',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        '& .image-actions': {
            opacity: 1
        }
    }
}));

export const ImageUploadActionWrapper = styled(Box)({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    opacity: 0,
    transition: 'opacity 0.2s ease-in-out',
    '&:hover': {
        opacity: 1
    }
});

export const ImageUploadActionButtonWrapper = styled(IconButton)({
    backgroundColor: 'white',
    width: '32px',
    height: '32px',
    padding: '6px',
    margin: '0 4px',
    '&:hover': {
        backgroundColor: '#f8fafc'
    },
    '& svg': {
        fontSize: '18px',
        color: '#64748b'
    }
});

export const ViewContentWrapper = styled(Stack)({
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px',
    alignItems: 'center'
});

export const ViewContentImageWrapper = styled.img({
    width: '160px',
    height: '160px',
    borderRadius: '50%'
});

export const ViewContentImagePostWrapper = styled.img({
    width: '80%',
    height: '80%'
});

export const ViewContentCardWrapper = styled(Card)({
    width: '100%',
    height: '100%',
    maxHeight: '500px',
    display: 'flex',
    justifyContent: 'flex-start',
    padding: '10px',
    overflowY: 'auto'
});

export const ViewContentCardWrapperFull = styled(Card)({
    width: '100%',
    height: 'auto',
    display: 'flex',
    justifyContent: 'flex-start',
    padding: '10px',
    overflowY: 'auto'
});

export const ViewContentHeadinAndDatagWrapper = styled(Stack)({
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'left'
});

export const ViewContentHeadingWrapper = styled(Typography)({
    fontWeight: 'bold'
});

export const ViewContentDataWrapper = styled(Typography)({
    fontFamily: 'Default'
});

export const ViewContentBioWrapper = styled(Card)({
    width: '350px',
    height: '200px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: '10px',
    overflowY: 'auto'
});
